import { RouterProvider } from 'react-router-dom';
import { initHttp } from '@/api/http';
import { router } from './router';
import './App.css';

const bffApiUrl = import.meta.env.PUBLIC_BFF_API_URL;

initHttp(bffApiUrl);

const App: React.FC = () => {
	return <RouterProvider router={router} />;
};

export default App;
